module.exports = __webpack_public_path__ + "img/pocoapoco_logo.96820b4f.png";